module.exports = __webpack_public_path__ + "img/thumb_01.30448ad8.jpg";